import React from "react";
import $ from "jquery";
import CleverTapSdk from "../../CleverTapSdk";
import { getParameterByName } from "../../Utils/Function";
import html2canvas from "html2canvas";
import GenerateCanvas from "../Common/GenerateCanvas";
import AWS from "aws-sdk/global";
import S3 from "aws-sdk/clients/s3";
import { ShareResults } from "./ShareResults";
import { Result } from "./Result";
export default class Question extends React.Component {
  constructor(props) {
    console.log('thisprops', props.allDetailsData.survey_title);
    super(props);
    this.state = {
      selectedOptionsId: "",
      selectedOptionTitle: "",
      timeRemain: "00:30",
      timeduration: "1",
      totalduration: "0",
      text: "I just took the MannKiBaat Quiz. Try it now on the Narendra Modi App! https://www.narendramodi.in/mkbquiz",
      openPopUp: false,
      downloadImageUrl: null,
      fbShareUrl: null,
      twitterShareUrl: null,
      whatsappLink: null,
    };

    AWS.config.region = "ap-south-1"; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: "ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f",
    });
    this.bucketname = "js-sdk-bucket";
    this.bucket = new AWS.S3({
      params: {
        Bucket: this.bucketname,
      },
    });
  }
  timerInt = null;
  UNSAFE_componentWillReceiveProps() {
    this.mainFunction();
  }
  mainFunction = () => {
    this.setState({ selectedOptionsId: "", selectedOptionTitle: "" });
    clearInterval(this.timerInt);
    if (Object.keys(this.props.question).length > 0 && !this.props.is_last) {
      // console.log("timer working", this.props);
      this.startTimer(30);
    }
  };
  async componentDidMount() {
    localStorage.setItem("quizStartTime", performance.now());
    let uid = "";
    uid = Math.random();
    this.setState(
      {
        canvasKey: "certificates/usercertificate" + uid + ".jpg",
        text: this.props.share_text && this.props.share_text,
      },
      () => {
        this.createShareUrl();
      }
    );
    this.startTimer(30);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.is_last && nextProps.finalMessage) {
      setTimeout(() => {
        this.generateCanvas();
      }, 1000);
    }
  }

  generateCanvas = async () => {
    let ref = this;

    html2canvas(document.querySelector("#generate_canvas_div"), {
      width: 1250,
      scale: 1,
    }).then(async (canvas) => {
      canvas.toBlob(async function (blob) {
        var file = new File([blob], "filename");
        let image =
          "https://campaign-images.narendramodi.in/" +
          ref.state.canvasKey +
          "?www.facebook.com=1";
        let url = `https://api.narendramodi.in/api/loadone?link=https://s3.ap-south-1.amazonaws.com/js-sdk-bucket/${ref.state.canvasKey}&www.facebook.com=1`;
        ref.setState({ image: image, downloadImageUrl: url }, () => {
          ref.props.saveUserCard(ref.state.image);
        });
        await ref.uploadToS3(file, "canvas", ref.bucket);
      }, "image/jpeg");
    });
  };

  uploadToS3 = async (file, type, bucket, callback) => {
    var objKey = null;
    if (type == "canvas") {
      objKey = this.state.canvasKey;
    }
    var params = {
      Key: objKey,
      ContentType: file.type ? file.type : "image/jpeg",
      Body: file,
      ACL: "public-read",
    };
    return await bucket.putObject(params).promise();
  };

  handleShare = () => {
    var org_url = "test";
    try {
      org_url = localStorage.getItem("org_url");
    } catch (e) {}
    try {
      if (org_url && org_url.indexOf("appversion") > -1) {
        var sharelink = `appshare://text=${this.state.text}  &imageurl=${this.state.image}`;
        try {
          let ctdata = {};
          ctdata["mkbsurvey_action"] = "Post Shared";
          ctdata["type"] = "appnative";
          ctdata["post_id"] = this.props.postid;
          ctdata["image"] = this.props.image;
          CleverTapSdk.handleEventtracking(ctdata, "Mkb Quiz 2021");
        } catch (error) {}
        window.location.href = sharelink;
      } else {
        this.handleNativeShare();
      }
    } catch (e) {
      this.handleNativeShare();
    }
  };

  handleNativeShare = async () => {
    let ref = this;
    let { sharedata } = this.props;
    let title = this.state.text;
    let text = this.state.text;
    let url = navigator.canShare;

    let data = {
      // files: [file],
      title,
      text,
      url,
    };

    try {
      if (navigator && navigator.canShare(data)) {
        if (this.state.image) {
          document.getElementById("preloader_mantra").style.display = "block";
          const response = await fetch(this.state.image);
          const blob = await response.blob();
          const file = new File([blob], `${title}_img.jpg`, {
            type: blob.type,
          });
          data["files"] = [file];
          navigator
            .share(data)
            .then(() => {})
            .catch((error) => console.log("Error sharing", error));
          document.getElementById("preloader_mantra").style.display = "none";
        }
      } else {
        this.setState({ openPopUp: true });
      }
    } catch (e) {
      console.log(
        "Native share only work for Chrome for Android v>=61 / Safari on iOS v>=12.2 / Safari v>=12.1 / Opera for Android v>=48 / Samsung Internet v>=8.0"
      );
      this.setState({ openPopUp: true });
    }
  };

  startTimer = (duration, finished = false) => {
    var timer = duration,
      minutes,
      seconds,
      remain;
    let thisVar = this;
    this.timerInt = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      remain = parseInt(30 - seconds);
      window.document.getElementById("timer").innerHTML =
        minutes + ":" + seconds;
      thisVar.setState({ timeRemain: minutes + ":" + seconds });
      thisVar.setState({ timeduration: remain });
      if (--timer < 0) {
        timer = duration;
        thisVar.submitQuestion();
      }
    }, 1000);
  };

  // submitQuestion = () => {
  //     // let thisObjs = this;
  //     this.props.submitAction(this.props.index, this.state.selectedOptionsId, this.state.selectedOptionTitle);
  //     this.setState({ submitQuestion: "" });
  // }

  submitQuestion = (timeout = "") => {
    try {
      let { options } = this.props.question;
      let useSelected = $(".active").attr("id");
      let userSelId = useSelected.split("_id").join("");
      let correctOption = options.filter((itm) => {
        if (itm.repair == 1) {
          return itm;
        }
      });

      if (correctOption[0]["options_id"] != userSelId) {
        $("#" + correctOption[0]["options_id"] + "_id").addClass("rightAns");
        $("#" + useSelected).addClass("active_wrong");
      } else {
        $("#" + correctOption[0]["options_id"] + "_id").addClass("rightAns");
      }
      this.setState({
        totalduration:
          parseInt(this.state.totalduration) +
          parseInt(this.state.timeduration),
      });
    } catch (error) {
      console.log(error.message);
    }
    let title = "";
    let optionid = "";
    title = this.state.selectedOptionTitle;
    optionid = this.state.selectedOptionsId;

    $(".loader1").css("display", "inline-block");
    $("button[id='submitButton']").attr("disabled", true);
    this.props.submitAction(
      this.props.index,
      optionid,
      title,
      parseInt(this.props.durations) + parseInt(this.state.timeduration)
    );
    this.setState({ submitQuestion: "" });
  };
  submitQuestionAuto = () => {
    let thisObjs = this;
    this.setState({ selectedOptionsId: "Not Answer" }, () => {
      thisObjs.props.submitAction(
        thisObjs.props.index,
        thisObjs.state.selectedOptionsId
      );
    });
  };

  setClevertap = async (type) => {
    try {
      let ctdata = {};
      ctdata["mkbsurvey_action"] = "Post Shared";
      ctdata["type"] = type;
      ctdata["surveyid"] = await getParameterByName("quizid");
      CleverTapSdk.handleEventtracking(ctdata, "Mkb Quiz 2021");
    } catch (error) {}
  };

  createShareUrl = async () => {
    let shareText;
    let shareUrl;
    let share_text;
    shareUrl = "http://nm4.in/dnldapp";
    shareText =
      "I just took the MannKiBaat Quiz. Try it now on the Narendra Modi App! https://www.narendramodi.in/mkbquiz";
    share_text = shareText ? shareText.split("#").join("") : "";

    let fbShareUrl =
      "https://www.facebook.com/dialog/feed?app_id=445815495479697&link=" +
      shareUrl +
      "&name=Narendra%20Modi&quote=" +
      share_text +
      "&redirect_uri=https%3A%2F%2Fwww.narendramodi.in";
    let twitterShareUrl =
      "https://twitter.com/intent/tweet?text= " +
      shareText +
      "&hashtags=&original_referer=";
    let whatsappLink = "https://api.whatsapp.com/send?text=" + shareText;
    this.setState(
      {
        fbShareUrl: fbShareUrl,
        twitterShareUrl: twitterShareUrl,
        whatsappLink: whatsappLink,
      },
      () => console.log("fbShareUrl", this.state.fbShareUrl)
    );
  };
  hideShareModal = () => {
    this.setState({ openPopUp: false });
  };

  selectOption = (selectedOptionsId, selectedOptionTitle) => {
    $(".queslist>div>div.active").removeClass("active");
    $("#" + selectedOptionsId + "_id").addClass("active");
    this.setState(
      {
        selectedOptionsId: selectedOptionsId,
        selectedOptionTitle: selectedOptionTitle,
      },
      () => console.log(selectedOptionsId)
    );
  };
  render() {
    let { question, index, is_last, finalMessage } = this.props;
    let { fbShareUrl, twitterShareUrl, whatsappLink } = this.state;
    let progress = parseInt((index + 1) * 10) + "%";
    return (
      <>
        {!is_last ? (
          <>
            <section className="">
              <div className="quiz_padding">
                <React.Fragment>
                  <div className="quiz_content">
                    <h3>{question.survey_question_title || ""}</h3>
                    <h5>Question {parseInt(index + 1)} of 10</h5>
                    <ul>
                      <li>
                        <div className="progress progressbar_height">
                          <div
                            className="progress-bar"
                            style={{ width: progress }}
                          ></div>
                        </div>
                      </li>
                      <li>
                        <p>
                          <span id="timer">{this.state.timeRemain}</span>
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div className="queslist">
                    {question.options &&
                      question.options.length > 0 &&
                      question.options.map((option, key) => {
                        return (
                          <div
                            className="ques"
                            key={option.options_id + "_option"}
                          >
                            <div
                              className="quiz_option"
                              id={option.options_id + "_id"}
                              onClick={() =>
                                this.selectOption(
                                  option.options_id,
                                  option.options_title
                                )
                              }
                            >
                              <span>{option.options_title}</span>
                            </div>
                          </div>
                        );
                      })}

                    <div className="">
                      <div className="quiz_nextbtn">
                        <button type="button" onClick={this.submitQuestion}>
                          NEXT &#8594;
                        </button>
                      </div>
                    </div>
                    <div className="disclimer">
                      <h4>PLEASE NOTE</h4>
                      <p>{this.props.complete_msg}</p>
                    </div>
                  </div>
                </React.Fragment>
              </div>
            </section>
          </>
        ) : (
          <Result
            handleShare={this.handleShare}
            finalMessage={finalMessage}
            downloadImageUrl={this.state.downloadImageUrl}
            score={this.props.score}
            durations={this.props.durations}
          />
        )}

        {this.state.openPopUp && (
          <ShareResults
            fbShareUrl={fbShareUrl}
            twitterShareUrl={twitterShareUrl}
            whatsappLink={whatsappLink}
            hideShareModal={this.hideShareModal}
            setClevertap={this.setClevertap}
          />
        )}
        {<GenerateCanvas score={this.props.score} title={this.props.allDetailsData.survey_title} />}
        {/* <div id="divLoading" style={{ display: this.state.isLoading ? "block" : "none" }}></div> */}
      </>
    );
  }
}
